function selectBundle(bundleOption) {
  const section = bundleOption.closest('[data-product-section]');
  if (!section || bundleOption.disabled) return;

  const quantity = Number(bundleOption.dataset.bundleQuantity) || 1;
  const quantityInput = section.querySelector('[data-bundle-quantity-input]');
  if (quantityInput) quantityInput.value = String(quantity);

  const returnToInput = section.querySelector('input[name="return_to"]');
  const discountCode = bundleOption.dataset.bundleDiscountCode;
  if (returnToInput) {
    returnToInput.value = discountCode
      ? `/discount/${encodeURIComponent(discountCode)}?redirect=/checkout`
      : '/checkout';
  }

  section.querySelectorAll('[data-bundle-quantity]').forEach((option) => {
    const selected = option === bundleOption;
    option.classList.toggle('is-selected', selected);
    option.setAttribute('aria-checked', selected ? 'true' : 'false');
  });

  const price = section.querySelector('[data-price-current]');
  const comparePrice = section.querySelector('[data-price-compare]');
  if (price) price.textContent = bundleOption.dataset.bundlePrice || '';
  if (comparePrice) {
    const compareValue = bundleOption.dataset.bundleComparePrice || '';
    comparePrice.textContent = compareValue;
    comparePrice.hidden = !compareValue;
  }
}

function bundleIsAvailable(variantOption, bundleOption) {
  if (variantOption.dataset.available !== 'true') return false;

  const quantity = Number(bundleOption.dataset.bundleQuantity) || 1;
  const tracked = variantOption.dataset.inventoryManaged === 'true';
  const denyOverselling = variantOption.dataset.inventoryPolicy === 'deny';
  const inventory = Number(variantOption.dataset.inventoryQuantity);

  return !(tracked && denyOverselling && Number.isFinite(inventory) && quantity > inventory);
}

document.addEventListener('click', (event) => {
  const thumb = event.target.closest('[data-gallery-thumb]');
  if (thumb) {
    const gallery = thumb.closest('[data-gallery]');
    const mainImage = gallery?.querySelector('#ProductMainImage');
    if (mainImage && thumb.dataset.largeImage) {
      mainImage.src = thumb.dataset.largeImage;
      mainImage.removeAttribute('srcset');
      gallery.querySelectorAll('[data-gallery-thumb]').forEach((button) => {
        button.classList.toggle('is-active', button === thumb);
        button.setAttribute('aria-pressed', button === thumb ? 'true' : 'false');
      });
    }
  }

  const stepper = event.target.closest('[data-quantity-step]');
  if (stepper) {
    const input = stepper.parentElement?.querySelector('input[name="quantity"]');
    if (!input) return;
    const min = Number(input.min) || 1;
    const current = Number(input.value) || min;
    input.value = String(Math.max(min, current + Number(stepper.dataset.quantityStep)));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  const bundleOption = event.target.closest('[data-bundle-quantity]');
  if (bundleOption) selectBundle(bundleOption);
});

document.addEventListener('change', (event) => {
  const select = event.target.closest('[data-variant-select]');
  if (!select) return;

  const option = select.selectedOptions[0];
  const section = select.closest('[data-product-section]');
  if (!option || !section) return;

  const price = section.querySelector('[data-price-current]');
  const comparePrice = section.querySelector('[data-price-compare]');
  const addButton = section.querySelector('[data-add-to-cart]');
  const addLabel = section.querySelector('[data-add-label]');

  const bundleOptions = Array.from(section.querySelectorAll('[data-bundle-quantity]'));
  bundleOptions.forEach((bundleOption) => {
    const quantity = bundleOption.dataset.bundleQuantity;
    bundleOption.disabled = !bundleIsAvailable(option, bundleOption);
    bundleOption.setAttribute('aria-disabled', bundleOption.disabled ? 'true' : 'false');

    if (bundleOption.dataset.bundleFixedPrice !== 'true') {
      const priceKey = `bundlePrice${quantity}`;
      const compareKey = `bundleComparePrice${quantity}`;
      const savingKey = `bundleSaving${quantity}`;
      const bundlePrice = option.dataset[priceKey] || '';
      const bundleComparePrice = option.dataset[compareKey] || '';
      const bundleSaving = option.dataset[savingKey] || '';

      bundleOption.dataset.bundlePrice = bundlePrice;
      bundleOption.dataset.bundleComparePrice = bundleComparePrice;

      const bundlePriceText = bundleOption.querySelector('[data-bundle-price-text]');
      const bundleCompareText = bundleOption.querySelector('[data-bundle-compare-text]');
      const bundleSavingText = bundleOption.querySelector('[data-bundle-saving-text]');
      if (bundlePriceText) bundlePriceText.textContent = bundlePrice;
      if (bundleCompareText) {
        bundleCompareText.textContent = bundleComparePrice;
        bundleCompareText.hidden = !bundleComparePrice;
      }
      if (bundleSavingText) bundleSavingText.textContent = bundleSaving ? `وفّر ${bundleSaving}` : '';
    }
  });

  const activeBundle = section.querySelector('[data-bundle-quantity].is-selected:not(:disabled)');
  const availableBundle = activeBundle || bundleOptions.find((bundleOption) => !bundleOption.disabled);
  if (availableBundle) {
    selectBundle(availableBundle);
  } else {
    if (price) price.textContent = option.dataset.price || '';
    if (comparePrice) {
      comparePrice.textContent = option.dataset.comparePrice || '';
      comparePrice.hidden = !option.dataset.comparePrice;
    }
  }

  if (addButton) addButton.disabled = !availableBundle;
  if (addLabel) addLabel.textContent = availableBundle ? 'اطلب الآن' : 'غير متوفر حاليًا';
});
